import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeRoundDoor: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-round-door"><path d="M9.5 16.75V20.25H3.75V8.90625L12 3.75L20.25 8.90625V20.25H14.5V16.75C14.5 15.3693 13.3807 14.25 12 14.25C10.6193 14.25 9.5 15.3693 9.5 16.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconHomeRoundDoor;
